/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration>): OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration {
        let obj = Object.assign(new OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration(), model);
        OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration>): OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration {
        if (!model) return null;
        return OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration.newInstance(<OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration) {
        if (!obj) return;

        models.OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
